const buttonStyle = {
  display: "grid",
  placeContent: "center",
  height: "36px",
  borderRadius: "9999px",
  padding: "8px 16px",
  cursor: "pointer",
  fontSize: "12px",
  fontFamily: "PP Formula",
};

export const buttonPrimaryStyle = (theme) => ({
  ...buttonStyle,
  border: "none",
  background:
    "linear-gradient(90deg, #003661 -14.07%, #003BFF 28.94%, #00AFFF 86.11%, #00D1C3 117.74%)",
  backgroundRepeat: "no-repeat",
  color: theme.text.inverse,
});

export const buttonSecondaryStyle = (theme) => ({
  ...buttonStyle,
  border: `1px solid ${theme.border.black15}`,
  background: theme.bg.general,
  color: theme.text.text,
});

export const buttonIconStyle = (theme) => ({
  all: "unset",
  cursor: "pointer",
});

export const buttonSubtleStyle = (theme) => ({
  ...buttonStyle,
  background: "transparent",
  color: theme.text.title,
  border: "none",
});

export const buttonSubtleLinkStyle = (theme) => ({
  ...buttonStyle,
  background: "transparent",
  color: theme.text.brand,
  border: "none",
});

export const buttonTertiaryStyle = (theme) => ({
  ...buttonStyle,
  borderRadius: "20px",
  border: `1px solid ${theme.border.black15}`,
  background: theme.bg.tertiary,
  color: theme.text.inverse,
});

export const buttonTransparentStyle = (theme) => ({
  ...buttonStyle,
  borderRadius: "20px",
  border: `1px solid ${theme.border.black15}`,
  background: theme.border.black50,
  color: theme.text.inverse,

  hover: {
    background: theme.bg.tertiary,
  },
});
